import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApplyModalService } from '@shared/services/apply-modal/apply-modal.service';
import { PrerequisitesJrFrontEnd, PrerequisitesQaEngineer, PrerequisitesTestAutomation, PrerequisitesAngularFramework } from './prerequisites.mock';

@Component({
  selector: 'app-prerequisites',
  templateUrl: './prerequisites.component.html',
  styleUrls: ['./prerequisites.component.scss'],
})
export class PrerequisitesComponent {
  currentRoute: string;
  course = '';
  isFrontEnd = true;
  studyHours: string;
  programDuration: string;
  programmingKnowledge: string;

  constructor(
    private router: Router,
    public applyModalService: ApplyModalService
  ) {
    this.currentRoute = this.router.url;
    if (this.currentRoute.includes('junior-front-end-developer')) {
      this.course = 'Jr. Front End Developer';
      this.studyHours = PrerequisitesJrFrontEnd.studyHours;
      this.programDuration = PrerequisitesJrFrontEnd.programDuration;
      this.programmingKnowledge = PrerequisitesJrFrontEnd.programmingKnowledge;
    } else if (this.currentRoute.includes('angular-framework')) {
      this.course = 'Angular Developer';
      this.isFrontEnd = false;
      this.studyHours = PrerequisitesAngularFramework.studyHours;
      this.programDuration = PrerequisitesAngularFramework.programDuration;
      this.programmingKnowledge =
        PrerequisitesAngularFramework.programmingKnowledge;
    } else if (this.currentRoute.includes('qa-engineer')) {
      this.course = 'Jr. QA Engineer';
      this.isFrontEnd = false;
      this.studyHours = PrerequisitesQaEngineer.studyHours;
      this.programDuration = PrerequisitesQaEngineer.programDuration;
      this.programmingKnowledge = PrerequisitesQaEngineer.programmingKnowledge;
    } else {
      this.course = 'Jr. Test Automation Engineer';
      this.isFrontEnd = false;
      this.studyHours = PrerequisitesTestAutomation.studyHours;
      this.programDuration = PrerequisitesTestAutomation.programDuration;
      this.programmingKnowledge =
        PrerequisitesTestAutomation.programmingKnowledge;
    }
  }
}